<template>
  <div class="PartsAlreadyDone">
    <img
      class="PartsAlreadyDone-img"
      src="https://formation.bienvenue.pro/images/Illustrations/eastwood-sign-in.png"
      alt="not found"
    />
    <div class="PartsAlreadyDone-error">400</div>
    <div class="PartsAlreadyDone-msg">{{ $t('part.alreadyAnswer') }}</div>
  </div>
</template>

<script>
'use strict'

export default {
  name: 'PartsAlreadyDone'
}
</script>

<style lang="scss">
.PartsAlreadyDone {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 80vh;
  &-img {
    width: 600px;
    height: auto;

    @media (max-width: $remove-logo) {
      display: none;
    }
  }
  &-error {
    padding: 0.75rem;
    font-size: 3rem;
    font-weight: 700;
  }
  &-msg {
    padding: 2rem;
    font-size: 2rem;
    text-align: center;
  }
}
</style>
